module.exports = __webpack_public_path__ + "media/images/pages/img_largeStore_02-dbd542c971aed8414c8c0f225474eadc.jpg";